import {Modal} from "../../../../components/modal/modal.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../utils/ag-grid-columns-utils.js";
import React, {useMemo} from "react";
import {FaTrash, FaVideo} from "react-icons/fa";
import {v4} from "uuid";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import Button from "../../../../components/button/button.jsx";

const VehiclesCameraTable = ({data, setData, disabled = false}) => {

  const destroyItemRenderer = ({ data }) => {
    if (disabled) return null;

    const handleRemove = () => {
      setData(prev => ({
        ...prev,
        video_cameras: prev.video_cameras.filter(
          camera =>
            (camera.cameraId ?? camera.vms_camera_id) !==
            (data.cameraId ?? data.vms_camera_id)
        )
      }));
    };

    return (
      <div className="flex items-center justify-center h-full">
        <Button target="danger" onClick={handleRemove}>
          <FaTrash/>
        </Button>
      </div>
    );
  };

  const columnDefs = useMemo(() => [
    {headerName: "id",  valueGetter: (params) => params.data.cameraId ?? params.data.vms_camera_id, hide: true},
    {headerName: "Câmeras", field: "cameraName", flex: 1},
    {headerName: "", field: "removeItem", width: 80, cellRenderer: destroyItemRenderer},
  ] ,[disabled])

  return(
      <AgGridReact
        getRowId={(params) => params.data.id ?? v4()}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        rowData={data}
        theme={aggridUtils.generalTheme({rowHeight: 50})}
        defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
        animateRows={false}
        suppressCellFocus={true}
        suppressRowHoverHighlight={true}
        gridOptions={{localeText: aggridUtils.localization()}}
      />
  )
}

export default VehiclesCameraTable;